<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="addItem">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="pid" slot-scope="params">
        <MySwitch :data="params.params" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="'维保类型配置'" :labelWidth="'110px'" :width="'548px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FixList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "article",
      breadcrumb: [
        { name: "系统设置", path: `/fix/list` },
        { name: "维保类型配置", path: `/fix/config` },
      ],
      formCtrl: [
        {
          label: "",
          keyName: "name",
          placeholder: "请填写维保类型",
          type: "text",
        },
      ],
      cols: [
        { keyName: "name", label: "维保类型" },
        { keyName: "sort", label: "排序" },
        { keyName: "pid", label: "是否显示", slot: 'pid' },
        { keyName: "user_name", label: "创建人" },
        { keyName: "created_at", label: "创建时间" },
      ],
      allBtnWidth: '100px',
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            this.getItem(data);
            this.showDialog();
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      viewMode: false,
      mform: { name: undefined },
      mrules: {
        name: [
          {
            required: true,
            message: '请填写维保类型',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "维保类型",
          keyName: "name",
          err: "请填写维保类型",
          type: "text",
        },
        {
          label: "排序",
          keyName: "sort",
          err: "请填写排序",
          type: "number",
          unit: "数字越大排序越靠前",
        },
        {
          label: "是否显示",
          keyName: "pid",
          type: "radio",
          options: [
            { label: '是', value: 0 },
            { label: '否', value: 1 },
          ],
        },
      ],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = { ...v }
          obj.open = v.pid + ''
          return obj
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id }) {
      console.log(id)
      let url = `${this.baseUrl}/updatepid `;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
          // 禁止隐藏，并刷新
          this.getList()
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    addItem() {
      delete this.mform.id;
      this.mform = { name: undefined, pid: 0 };
      this.showDialog();
    },
    getItem({ id, name,sort,pid }) {
      this.mform = { ...this.mform, id, name,sort,pid};
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.fillet {
  height: auto;
  margin: 0 auto;
  padding: 20px 0px 10px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);
}

.retrieval {
  height: auto;
  /* overflow: hidden; */
  margin: 0px 20px;
  font-size: 14px;
  color: #606266;

  /deep/ .el-button {
    margin-bottom: 22px;
    padding: 12px 20px;
  }
}
/deep/ .dialog {
  .el-form {
    padding-right: 0 !important;

    .el-form-item .el-form-item__content .content {
      display: block;

      .unit {
        line-height: 30px;
        margin: 0 auto;
        font-size: 12px;
        color: #FF6756;
      }
    }

    .el-input {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>
